import axios from 'axios'

const state = () => ({
  interactive: []
})

const getters = {
  interactive(state) {
    return state.interactive
  }
}

const mutations = {
  SET_INTERACTIVE(state, payload){
    state.interactive = payload
  },
  DELETE_INTERACTIVE(state, id){
    state.interactive = state.interactive.filter((x) => x.id != id);
  },
  ADD_INTERACTIVE(state, data){
    state.interactive.push(data);
  },
  EDIT_INTERACTIVE(state, payload){
    state.interactive = state.interactive.map((vm)=>{
      if(vm.id == payload.id){return payload}
      else{ return vm }
    })
  }
}

const actions = {
  getInteractive({commit}){
    axios.get('https://api.geomalaka.uz/api/main/interaktiv-xizmatlar/')
    .then((res)=>{
      commit("SET_INTERACTIVE", res.data)
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  deleteInteractive({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/main/interaktiv-xizmatlar/${id}/`)
    .then((res)=>{
      commit("DELETE_INTERACTIVE", id)
      this._vm.$toast('Deleted', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  addInteractive({commit}, payload){
    axios.post('https://api.geomalaka.uz/api/main/interaktiv-xizmatlar/', payload)
    .then((res)=>{
      commit("ADD_INTERACTIVE", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  editInteractive({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/main/interaktiv-xizmatlar/${payload.id}/`, payload.data)
      .then((res)=>{
        commit("EDIT_INTERACTIVE", res.data)
        this._vm.$toast('Successful', {type: 'success'});
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

